import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Globe, DollarSign } from 'lucide-react';

const ACCOMMODATIONS = [
  {
    id: '1',
    name: '尖石薰衣草森林',
    nameEn: 'Jianshi Lavender Cottage',
    address: '新竹縣尖石鄉嘉樂村7鄰135號',
    phone: '03-584-2013',
    website: 'https://example.com',
    priceMin: 2800,
    priceMax: 5600,
  },
  {
    id: '2',
    name: '司馬庫斯部落民宿',
    nameEn: 'Smangus Tribal B&B',
    address: '新竹縣尖石鄉玉峰村14鄰司馬庫斯',
    phone: '03-584-7688',
    website: '',
    priceMin: 2000,
    priceMax: 3500,
  },
  {
    id: '3',
    name: '尖石溫泉渡假村',
    nameEn: 'Jianshi Hot Spring Resort',
    address: '新竹縣尖石鄉錦屏村8鄰15號',
    phone: '03-584-1888',
    website: 'https://example.com',
    priceMin: 3200,
    priceMax: 6800,
  },
  {
    id: '4',
    name: '那羅部落民宿',
    nameEn: 'Naluo Tribal Lodge',
    address: '新竹縣尖石鄉錦屏村那羅3鄰',
    phone: '03-584-2576',
    website: '',
    priceMin: 1500,
    priceMax: 2500,
  },
  {
    id: '5',
    name: '關西六福莊',
    nameEn: 'Leofoo Resort Guanxi',
    address: '新竹縣關西鎮仁安里拱子溝60號',
    phone: '03-547-5365',
    website: 'https://example.com',
    priceMin: 8000,
    priceMax: 15000,
  },
];

export default function AccommodationPage() {
  const { t, i18n } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="section-title">{t('accommodation.title')}</h1>
      <p className="section-subtitle">{t('accommodation.subtitle')}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ACCOMMODATIONS.map((acc) => (
          <div key={acc.id} className="card">
            <h3 className="font-bold text-lg mb-4">
              {i18n.language === 'en' ? acc.nameEn : acc.name}
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2 text-text-secondary">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
                <span>{acc.address}</span>
              </div>
              <div className="flex items-center gap-2 text-text-secondary">
                <DollarSign className="w-4 h-4 shrink-0 text-primary" />
                <span>
                  {t('accommodation.priceRange')}: NT${acc.priceMin.toLocaleString()} ~ ${acc.priceMax.toLocaleString()}{t('accommodation.perNight')}
                </span>
              </div>
              <div className="flex items-center gap-2 text-text-secondary">
                <Phone className="w-4 h-4 shrink-0 text-primary" />
                <span>{acc.phone}</span>
              </div>
              {acc.website && (
                <div className="flex items-center gap-2">
                  <Globe className="w-4 h-4 shrink-0 text-primary" />
                  <a
                    href={acc.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    {t('accommodation.website')}
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
